import { ConfirmationDialog } from '../Dialogs/ConfirmationDialog';
import React from 'react';
import { Node } from '../../domain/domain';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { ComponentManagementActionType } from '../../reducers/comp.actions';

type Props = {
    onApprove: (node: Node) => void
}

const ApproveComponentDialog : React.FC<Props> = ({onApprove}) => {

    const open = useSelector((app: ApplicationState) => app.comp.approveComponentDialogOpen);
    const treeRoot = useSelector((app: ApplicationState) => app.comp.treeRoot);
    const editorNode = useSelector((app: ApplicationState) => app.comp.editorNode);
    const dispatch = useDispatch();

    if (!editorNode || !treeRoot) {
        return <></>
    }
    
    return (
        <ConfirmationDialog 
            open={open}
            title="Approve Component"
            contentText="Are you sure you want to approve this component?"
            handleNo = {() => {
                dispatch({type: ComponentManagementActionType.APPROVE_COMPONENT_DIALOG_OPEN, open: false});
            }}
            handleYes = {() => {
                onApprove(editorNode);
                dispatch({type: ComponentManagementActionType.APPROVE_COMPONENT_DIALOG_OPEN, open: false});
            }}
        />
    )
}

export default ApproveComponentDialog;